import React from "react";
import { GrantDto } from "../../../../dtos/GrantDto";
import { PhaseDto } from "../../../../dtos/PhaseDto";
import { StepDto } from "../../../../dtos/StepDto";
import { TaskStatusIconView } from "./components/TaskStatusIconView";
import { useTaskStatusIconController } from "./hooks/useTaskStatusIconController";

export interface ITaskStatusIconProps {
    phase: PhaseDto | null;
    // Subtasks in view. Step-style tasks derive their overall status from these.
    steps?: StepDto[] | null;
    onStatusIconClick?: () => void;
    textOnly?: boolean;
    grantData?: GrantDto | null;
    // Task collapse, folded into the status icon (ticket 1034). Omit the handler and no
    // expander is drawn at all.
    collapsed?: boolean;
    onToggleCollapsed?: () => void;
    subtaskCount?: number;
}

export default function TaskStatusIcon(props: ITaskStatusIconProps) {
    const ctrl = useTaskStatusIconController(props);
    return <TaskStatusIconView {...ctrl} />;
}
